import moment from "moment"
import { FC, useEffect } from "react"
import { IHallBooking } from "src/domain/entities"
import { hallBookingBillAddService } from "src/domain/services/hallBookingBill/hallBookingBillAddService"
import { useItemListService } from "src/hooks"
import { useHallBookingReceiptListService } from "src/hooks/hallBookingReceipt"
import { useAuth } from "src/hooks/useAuth"
import { IHallBookingBillAddFormFields } from "."
import { HallBookingBillAddDrawerFormView } from "./HallBookingBillAddDrawerFormView"

interface Props {
	hallBooking?: IHallBooking
	onSuccess: () => void
	isOpen: boolean
	onClose: () => void
}

export const HallBookingBillAddDrawerFormController: FC<Props> = ({
	hallBooking,
	onSuccess,
	isOpen,
	onClose,
}) => {
	const { token } = useAuth()
	const { hallBookingReceiptList, fetchHallBookingReceiptList } =
		useHallBookingReceiptListService()
	const { itemList, fetchItemList } = useItemListService()

	useEffect(() => {
		if (isOpen) {
			fetchHallBookingReceiptList()
			fetchItemList()
		}
	}, [isOpen, fetchHallBookingReceiptList, fetchItemList])

	const handleSubmit = async (values: IHallBookingBillAddFormFields) => {
		try {
			await hallBookingBillAddService(
				{
					...values,
					billNo: +values.billNo,
					date: moment(values.date).valueOf(),
					bookingId: hallBooking?.id || "",
				},
				token,
			)
			onSuccess()
			onClose()
		} catch (error) {
			console.error("Error adding hall booking bill:", error)
		}
	}

	return (
		<HallBookingBillAddDrawerFormView
			isOpen={isOpen}
			onClose={onClose}
			handleSubmit={handleSubmit}
			hallBookingReceiptList={hallBookingReceiptList}
			itemList={itemList}
			hallBooking={hallBooking}
		/>
	)
}
